import React from 'react';
import PropTypes from 'prop-types';
import GenericButton from './GenericButton';
import { copyContent } from '../../util/CommonUtils';
import { shortLabelText, filterLabel } from '../../util/CrosstabUtils';


const renderText = (selectedGridData, selectedGrid, index) => {
  let gridTitle = '';
  if (selectedGridData && selectedGridData.objectsAdded) {
    const objectsAdded = selectedGridData.objectsAdded;
    if (objectsAdded.length > 0 && objectsAdded.length === 1) {
      if (objectsAdded[0].breadcrumbs !== objectsAdded[0].keyword) {
        gridTitle = objectsAdded[0].dataSmartSearchObjectsCreated
          ? objectsAdded[0].breadcrumbs
          : filterLabel(`${objectsAdded[0].shortTextCatgView}`, `${objectsAdded[0].breadcrumbs}`);
      } else {
        gridTitle = `${objectsAdded[0].shortText} `;
      }
    } else {
      gridTitle = '';
      objectsAdded.forEach(item => {
        let textValue = '';
        if (item.breadcrumbs && item.breadcrumbs !== item.keyword) {
          textValue = item.dataSmartSearchObjectsCreated
            ? item.breadcrumbs
            : filterLabel(`${item.shortTextCatgView}:`, `${item.breadcrumbs}`);
        } else if (!item.isLabelUpdated && item.objectType === 'operator') {
          textValue = `${textValue} ${item.shortText} `;
        } else if (item.breadcrumbs === item.keyword) {
          textValue = `${textValue} ${item.shortText}`;
        }
        gridTitle += textValue;
      });
    }
    gridTitle = gridTitle.length < 25
      ? gridTitle
      : shortLabelText(gridTitle);
  } else if (selectedGrid.selectedNames && selectedGrid.selectedNames[index]) {
    gridTitle = `${selectedGrid.selectedNames[index]}`;
  }
  return gridTitle;
};

const renderCopyData = (gridTitle, selectedGrid) => {
  if (selectedGrid.selectedKeywords.length > 0) {
    return `${gridTitle} [${
      selectedGrid.selectedKeywords.length
      }]:\r\n${
      gridTitle === 'Bases'
        ? selectedGrid.selectedKeywords.map((selectedKeyword, index) =>
          `${selectedGrid.selectedNames[index]}`,
        ) : selectedGrid.dataSmartSearch.map((data, index) =>
          `${renderText(data, selectedGrid, index)}`
        )
          .join('\r\n')}\r\n`;
  }
  return '';
};

const renderData = (gridTitle, selectedGrid) => {
  if (selectedGrid.selectedKeywords.length > 0) {
    return (
      <div>
        <h4>
          <b>{`${gridTitle} [${selectedGrid.selectedKeywords.length}]`}:</b>
        </h4>
        {gridTitle === 'Bases'
          ? selectedGrid.selectedKeywords.map((selectedKeyword, index) => (
            <div key={selectedKeyword}>{`${selectedGrid.selectedNames[index]}`}</div>
          ))
        : selectedGrid.dataSmartSearch.map((data, index) => (
          <div key={selectedGrid.selectedKeywords[index]}>{renderText(data, selectedGrid, index)}</div>
        ))}
      </div>
    );
  }

  return <div />;
};

const renderTrendProducts = (trendStudies, gridsValidationResponse, crosstabStudy, selectedGrid, dataScreen) => {
  const currentStudy = crosstabStudy.pn;
  const currentStudyDesc = crosstabStudy.sd;
  const productLists = { [currentStudy]: currentStudyDesc };
  trendStudies.map(elems => {
    productLists[elems.pn] = elems.sd;
    return null;
  });

  const productDataValidateElemsArr = [];
  const ValidationMessage = 'The following items are not available in the below study(s): ';
  let copyContentArr = `${ValidationMessage}`;
  const invalidProductList = {};
  if (gridsValidationResponse.trendProducts) {
    gridsValidationResponse.trendProducts.map((elems, index) => {
      const invalidDataList = [];

      elems.baseList.map(data => {
        if (!data.valid) {
          invalidDataList.push(data.label);
        }
        return null;
      });
      elems.colList.map(data => {
        if (!data.valid) {
          invalidDataList.push(data.label);
        }
        return null;
      });
      elems.rowList.map(data => {
        if (!data.valid) {
          invalidDataList.push(data.label);
        }
        return null;
      });
      if (index === 0 && invalidDataList.length > 0) {
        invalidProductList[currentStudy] = invalidDataList;
      } else if (invalidDataList.length > 0) {
        const trendStudy = trendStudies[index - 1].pn;
        invalidProductList[trendStudy] = invalidDataList;
      }
      return null;
    });
  } else {
    const invalidDataList = [];
    gridsValidationResponse.baseList.map(data => {
      if (!data.valid) {
        invalidDataList.push(data.label);
      }
      return null;
    });
    gridsValidationResponse.colList.map(data => {
      if (!data.valid) {
        invalidDataList.push(data.label);
      }
      return null;
    });
    gridsValidationResponse.rowList.map(data => {
      if (!data.valid) {
        invalidDataList.push(data.label);
      }
      return null;
    });
    invalidProductList[currentStudy] = invalidDataList;
  }

  for (const key in invalidProductList) {
    productDataValidateElemsArr.push(
      <div>
        <div className="row">
          <h4>
            <b className="padding-20">{`Study Name: ${
              productLists[key]
              }`}
            </b>
          </h4>
        </div>
        <div className="row" />
        <div className="row invalid-grid-data">
          {dataScreen === undefined && renderData('Columns', selectedGrid.columnsGrid)}
          {renderData('Rows', selectedGrid.rowsGrid)}
          {dataScreen === undefined && renderData('Bases', selectedGrid.basesGrid)}
        </div>
      </div>
    );

    copyContentArr +=
      `\n\nStudy Name: ${
      productLists[key]
      }\n\n${renderCopyData('Columns', selectedGrid.columnsGrid)}
      \n${renderCopyData('Rows', selectedGrid.rowsGrid)}
      \n${renderCopyData('Bases', selectedGrid.basesGrid)}`;
  }
  return (<div>
    <div className="row margin-0">
      <div className="large-10 columns">
        <h4>The following items are not available in the following study(s):</h4>
      </div>
      <div className="large-2 columns">
        <GenericButton
          name="copy"
          onBtnClick={() => copyContent(copyContentArr)}
        />
      </div>
    </div>
    {productDataValidateElemsArr}
  </div>);
};

const ValidateMultipleStudyModal = props => (
  <div>
    {
      props.dataScreen === undefined &&
      renderTrendProducts(
        props.trendStudies,
        props.gridsValidationResponse,
        props.crosstabStudy,
        props.invalidData,
        props.dataScreen
        )
    }
    <div className="modal-footer">
      <GenericButton
        name="OK"
        btnStyle="button btn-cncl float-right"
        onBtnClick={() => props.handleParentHide()}
      />
    </div>
  </div>
);

ValidateMultipleStudyModal.propTypes = {
  handleParentHide: PropTypes.func,
  moduleStudy: PropTypes.shape({
    sd: PropTypes.string,
  }),
  trendStudies: PropTypes.shape({}),
  invalidData: PropTypes.shape({
    columnsGrid: PropTypes.shape({}),
    rowsGrid: PropTypes.shape({}),
    basesGrid: PropTypes.shape({}),
  }),
  dataScreen: PropTypes.string,
  gridsValidationResponse: PropTypes.shape({}),
  crosstabStudy: PropTypes.shape({}),
};

export default ValidateMultipleStudyModal;
